module.exports = __webpack_public_path__ + "static/media/172.c7dcf67a.wav";